module.exports = __webpack_public_path__ + "img/team-banner@2x.18738a2f.png";